import { gql } from '@apollo/client';
import { EPIC_FIELDS_FRAGMENT, EPIC_USERS_FIELDS_FRAGMENT } from './fragments/epic';
import { TASK_WITH_RESOURCED_FIELDS_FRAGMENT } from './fragments/task';
import { PROJECTS_CONTAINER_EPICS_FRAGMENT } from '../../containers/ProjectsContainer/api/fragments/fragments';
import {
    PLANNING_WORKPACKAGE_FIELDS_FRAGMENT,
    WORKPACKAGE_SUMMARY_FIELDS_FRAGMENT
} from './fragments/workpackage';

export const GET_EPIC_AUTOCOMPLETE = gql`
    query epicAutocomplete($Search: String, $From: Int, $To: Int, $EpicIds: [Int!]) {
        epicRows(data: { Search: $Search, From: $From, To: $To, EpicIds: $EpicIds }) {
            TotalRowCount
            Epic {
                EpicId
                Name
                EpicNbr
                CoordinateSystemType {
                    CoordinateSystemTypeId
                    Name
                    DatumCode
                }
                HeightSystemType {
                    HeightSystemTypeId
                    Name
                }
                DataOwner
                Secret
            }
        }
    }
`;

export const GET_EPICS = gql`
    query epics {
        epics {
            ...EpicFields
        }
    }
    ${EPIC_FIELDS_FRAGMENT}
`;

export const GET_EPIC_BY_ID = gql`
    query getEpicById($EpicId: Int!) {
        epicById(data: { EpicId: $EpicId }) {
            ...EpicFields
        }
    }
    ${EPIC_FIELDS_FRAGMENT}
`;

export const GET_EPIC_USERS = gql`
    query getEpicUsers($EpicId: Int!) {
        epicById(data: { EpicId: $EpicId }) {
            ...EpicUserFields
        }
    }
    ${EPIC_USERS_FIELDS_FRAGMENT}
`;

export const GET_ORGANIZATION_EPICS = gql`
    query epicByOrganizationId($OrganizationId: Int!) {
        epicByOrganizationId(data: { OrganizationId: $OrganizationId }) {
            ...EpicFields
        }
    }
    ${EPIC_FIELDS_FRAGMENT}
`;

export const GET_EPIC_TASK = gql`
    query getEpicTasks($EpicId: Int!) {
        epicById(data: { EpicId: $EpicId }) {
            EpicId
            Tasks {
                ...TaskResourcedFields
            }
        }
    }
    ${TASK_WITH_RESOURCED_FIELDS_FRAGMENT}
`;

export const GET_EPICSTATUS = gql`
    query EpicStatus {
        epicStatuses {
            EpicStatusId
            Name
        }
    }
`;

export const DELETE_EPIC = gql`
    mutation deleteEpic($EpicId: Int!) {
        deleteEpic(data: { EpicId: $EpicId })
    }
`;

export const CREATE_EPIC = gql`
    mutation createEpic(
        $EpicName: String!
        $CoordinateSystemTypeId: Int!
        $HeightSystemTypeId: Int!
        $EpicNumber: String!
        $Description: String
        $Budget: String
        $Target: String
        $StartDate: Date
        $EndDate: Date
        $DataOwner: String
        $Secret: Boolean
        $EpicPhaseTypeId: Int
    ) {
        createEpic(
            data: {
                Name: $EpicName
                CoordinateSystemTypeId: $CoordinateSystemTypeId
                HeightSystemTypeId: $HeightSystemTypeId
                EpicNbr: $EpicNumber
                Description: $Description
                Budget: $Budget
                Target: $Target
                StartDate: $StartDate
                EndDate: $EndDate
                DataOwner: $DataOwner
                Secret: $Secret
                EpicPhaseTypeId: $EpicPhaseTypeId
            }
        ) {
            ...EpicFields
        }
    }
    ${EPIC_FIELDS_FRAGMENT}
`;

//add once epic owner is added to query
//EpicOwner: $EpicOwner
// $EpicOwner: String

export const UPDATE_EPIC = gql`
    mutation updateEpic(
        $EpicId: Int!
        $EpicName: String
        $CoordinateSystemTypeId: Int
        $HeightSystemTypeId: Int
        $EpicNumber: String
        $EpicStatusId: Int
        $Description: String
        $Budget: String
        $Target: String
        $StartDate: Date
        $EndDate: Date
        $DataOwner: String
        $Secret: Boolean
        $AddEpicUsers: [UpdateEpicAddUsersInputType!]
        $RemoveEpicUsers: [UpdateEpicRemoveUsersInputType!]
        $EpicPhaseTypeId: Int
    ) {
        updateEpic(
            data: {
                EpicId: $EpicId
                Name: $EpicName
                CoordinateSystemTypeId: $CoordinateSystemTypeId
                HeightSystemTypeId: $HeightSystemTypeId
                EpicNbr: $EpicNumber
                EpicStatusId: $EpicStatusId
                Description: $Description
                Budget: $Budget
                Target: $Target
                StartDate: $StartDate
                EndDate: $EndDate
                DataOwner: $DataOwner
                Secret: $Secret
                AddEpicUsers: $AddEpicUsers
                RemoveEpicUsers: $RemoveEpicUsers
                EpicPhaseTypeId: $EpicPhaseTypeId
            }
        ) {
            ...EpicFields
        }
    }
    ${EPIC_FIELDS_FRAGMENT}
`;

export const GET_USER_EPICROLES = gql`
    query userEpicRoleTypes {
        userEpicRoleTypes {
            UserEpicRoleTypeId
            Name
        }
    }
`;

export const ADD_USER_EPICROLE = gql`
    mutation addUserEpicRole($EpicId: Int!, $UserId: Int!, $UserEpicRoleTypeId: Int!) {
        addUserEpicRole(
            data: { EpicId: $EpicId, UserId: $UserId, UserEpicRoleTypeId: $UserEpicRoleTypeId }
        ) {
            ...ProjectsContainerEpics
        }
    }
    ${PROJECTS_CONTAINER_EPICS_FRAGMENT}
`;

export const REMOVE_USER_EPICROLE = gql`
    mutation removeUserEpicRole($EpicId: Int!, $UserId: Int!, $UserEpicRoleTypeId: Int!) {
        removeUserEpicRole(
            data: { EpicId: $EpicId, UserId: $UserId, UserEpicRoleTypeId: $UserEpicRoleTypeId }
        ) {
            ...ProjectsContainerEpics
        }
    }
    ${PROJECTS_CONTAINER_EPICS_FRAGMENT}
`;

export const ADD_USER_EPICROLE_TO_ORGANIZATION = gql`
    mutation addUserEpicRoleOwnOrganization($EpicId: Int!) {
        addUserEpicRoleOwnOrganization(data: { EpicId: $EpicId }) {
            ...ProjectsContainerEpics
        }
    }
    ${PROJECTS_CONTAINER_EPICS_FRAGMENT}
`;

export const ASSING_EPIC_TO_USER = gql`
    mutation epicAssign($EpicId: Int!, $UserId: Int!) {
        epicAssign(data: { EpicId: $EpicId, UserId: $UserId }) {
            ...PlanningWorkPackageFields
            WorkPackageSummary {
                ...WorkPackageSummaryFields
            }
        }
    }
    ${PLANNING_WORKPACKAGE_FIELDS_FRAGMENT}
    ${WORKPACKAGE_SUMMARY_FIELDS_FRAGMENT}
`;

export const UPDATE_EPIC_STATUS = gql`
    mutation updateEpicStatus($EpicId: Int!, $EpicStatusId: Int) {
        updateEpic(data: { EpicId: $EpicId, EpicStatusId: $EpicStatusId }) {
            ...ProjectsContainerEpics
        }
    }
    ${PROJECTS_CONTAINER_EPICS_FRAGMENT}
`;
